"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translations = {
    inOutRange: {
        en: "The value is out of range.",
        es: "El valor está fuera de rango.",
    },
    onlyNumbers: {
        en: "The field can only contain numbers.",
        es: "El campo solo puede contener números.",
    },
    initialTime: {
        en: "Initial time",
        es: "Hora inicial",
    },
    finalTime: {
        en: "Final time",
        es: "Hora final",
    },
    showAddress: {
        en: "Show address",
        es: "Ver dirección",
    },
    minGeofencesArea: {
        en: "Draw a min area of {area}",
        es: "Dibuje un área mínima de {area}",
    },
    geofencesConfirm: {
        en: "Are you sure you want to save without devices?",
        es: "¿Está seguro de que quiere guardar sin dispositivos?",
    },
    drawnArea: {
        en: "Area {area} less than required",
        es: "Área {area} menor a la requerida",
    },
    providerApple: {
        en: "Provider Apple",
        es: "Proveedor Apple",
    },
    providerGoogle: {
        en: "Provider Google",
        es: "Proveedor Google",
    },
    clusteringEnable: {
        en: "Clustering enable",
        es: "Habilitar agrupación",
    },
    unauthorized: {
        en: "Optimus does not have access to your location. To enable access, on your phone, open the Settings app.",
        es: "Optimus no tiene acceso a su ubicación. Para habilitar el acceso, en su teléfono, abra la aplicación Configuración.",
    },
    rememberMeFailed: {
        en: "There was an error while saving remember me.",
        es: "Hubo un error al guardar las credenciales de acceso.",
    },
    session: {
        en: "Session",
        es: "Sesión",
    },
    profileChangePicture: {
        en: "Change profile picture",
        es: "Cambiar foto de perfil",
    },
    selectImage: {
        en: "Select Image",
        es: "Seleccionar Imagen",
    },
    namePlaceholder: {
        en: "Type a name",
        es: "Escriba un nombre",
    },
    selectDevices: {
        en: "Select units",
        es: "Seleccionar unidades",
    },
    selectAccount: {
        en: "Select users",
        es: "Seleccionar usuarios",
    },
    selectApp: {
        en: "What app would you like to use?",
        es: "¿Qué aplicación te gustaría usar?",
    },
    tutorials: {
        en: "Tutorials",
        es: "Tutoriales",
    },
    tutorialConnectionError: {
        en: "We couldn't load the tutorial, please check your internet connection.",
        es: "No pudimos cargar el tutorial, verifique su conexión a Internet.",
    },
    noGpsSignal: {
        en: "No GPS signal. Showing estimated location.",
        es: "Sin señal de GPS. Mostrando ubicación estimada.",
    },
    gpsSignalFeedback: {
        en: "Take your GPS tracker outside so it receives GPS signal.",
        es: "Lleve su rastreador GPS afuera para que reciba la señal GPS.",
    },
    open: {
        en: "Open",
        es: "Abrir",
    },
    downloadApp: {
        en: "You have downloaded the incorrect app. Click on the link below to download Optimus Tracking from the {store}.",
        es: "Ha descargado la aplicación incorrecta. Haga clic en el enlace a continuación para descargar Optimus Tracking desde la {store}.",
    },
    biometricsFeedback: {
        en: "By enabling biometric ID, you can access your account quickly and securely.",
        es: "Al habilitar la identificación biométrica le permite acceder a su cuenta de manera rápida y segura.",
    },
    appearance: {
        en: "Appearance",
        es: "Aspecto",
    },
    light: {
        en: "Light",
        es: "Claro",
    },
    dark: {
        en: "Dark",
        es: "Obscuro",
    },
    system: {
        en: "System",
        es: "Sistema",
    },
    availableAlerts: {
        en: "Available Alerts",
        es: "Alertas Disponibles"
    },
    disableAlerts: {
        en: "Disable Alerts",
        es: "Alertas Desactivadas"
    },
    contactYourAdmin: {
        en: "Contact your Admin",
        es: "Contacta a tu Administrador"
    },
    deviceSettings: {
        en: "Device Settings",
        es: "Ajustes de Unidades"
    },
    selectIcon: {
        en: "Select Icon",
        es: "Seleccionar Icono"
    },
    deleteAuthorizedSchedule: {
        en: "Delete Schedule",
        es: "Eliminar Horario"
    },
    noContent: {
        en: "No content",
        es: "Sin contenido"
    },
    liveDisclaimer: {
        en: "To protect your data usage, the live-streaming will last 2 minutes. Select the channel again to restart the live-stream.",
        es: "Para proteger tus datos, la transmisión solo durará 2 minutos. Seleccione el canal nuevamente para reiniciar la transmisión.",
    },
    behaviors: {
        en: "Behaviors",
        es: "Comportamientos",
    },
    geofenceInfo: {
        en: "A Geofence is defined by drawing a virtual perimeter around a specific location on the map. You will receive a notification whenever your GPS device leaves, enters, parks, or speeds within the perimeter you draw.",
        es: "Una geocerca se define trazando un perímetro virtual alrededor de una ubicación específica en el mapa. Recibirá una notificación cada vez que su dispositivo GPS salga, entre, se estacione o exceda la velocidad dentro del perímetro que dibuje.",
    },
};
exports.default = translations;
